<template>
  <section>
    <div class="left" v-if="StoreID==0">
      <ul class="leftmenu">
        <li v-for="item in list" v-on:click="OnliClick(item.AreaID,item.AreaName)" :class="selectArea==item.AreaID?'active':''">{{item.AreaName}}</li>
      </ul>
    </div>
  </section>
</template>
<script>
import { BzAjax, BzJs, BzMsg, BzUser } from "../assets/script/utils";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  name: "Left",
  data() {
    return {
      ShowType: 1,
      list: [],
      UserName: BzUser.get().UserName,
      selectArea: 0,
      selectType: 0,
      StoreID: 0,
      StoreName: "",
      StoreType: 0,
      containeriframeurl: "",
      ydvMonitorID: 0,
    };
  },
  created() {
    let user = BzUser.get();
    if (user.IsLogin != 0) {
      {
        this.getlist();
      }
    }
  },
  computed: {
    ...mapGetters({ store: "getState" }),
  },
  methods: {
    OnliClick: function (AreaID, AreaName) {
      this.selectArea = AreaID;
      this.$store.commit("setState", {
        StoreID: 0,
        StoreName: "",
        selectArea: this.selectArea,
      });
      this.$router.push("/default/" + this.selectArea + "/" + AreaName);
    },
    getlist: function () {
      BzAjax.postOs("/WSD/Area/GetUserArea", {}, (d) => {
        this.list = d.Areas;
        this.StoreID = d.StoreID;
        this.StoreName = d.StoreName;
        if (d.StoreType == 1) {
          this.StoreType = d.StoreType;
        }

        if (d.StoreID != 0) {
          this.$store.commit("setState", {
            StoreID: d.StoreID,
            StoreName: d.StoreName,
            selectArea: 0,
            StoreType: this.StoreType,
          });
          this.$router.push({
            name: "rightls",
            params: {
              StoreID: d.StoreID,
              StoreType: this.StoreType,
              AreaID: 0,
              Status: 0,
            },
          });
        } else {
          this.selectArea = d.Areas[0].AreaID;
          this.$store.commit("setState", {
            StoreID: 0,
            StoreName: "",
            selectArea: this.selectArea,
          });
          this.$router.push(
            "/default/" + d.Areas[0].AreaID + "/" + d.Areas[0].AreaName
          );
        }
      });
    },
  },
};
</script>
<style lang="less">
.leftmenu {
  padding-bottom: 0px;
  margin-bottom: 0px;
  height: calc(100vh - 110px);
  /*height: 85vh;*/
  overflow-y: scroll;
}
.left {
  background: #f0f9fd;
  width: 100px;
  text-align: center;
  height: calc(100vh - 110px);
  display: inline-block;
  .leftmenu li {
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 1px solid #fff;
    font-size: 15px;
  }
  .leftmenu li.active {
    background: url(../assets/images/libg.png) no-repeat;
    background-size: 100% 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/left.vue